<!-- slider -->
<div class="layout {{ slider }}">
  <div class="sidebar">
    <a [routerLink]="['/admin']" class="my-logo white">
      <svg viewBox="0 0 127 122" fill="none">
        <path d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z" />
        <path d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z" />
        <path d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z" />
        <path d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z" />
        <path d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z" />
      </svg>
      <div class="my-logo--content">
        <div class="my-logo--content__beta">Admin</div>
        <div class="my-logo--content__title">Kachiing</div>
        <div class="my-logo--content__desc">We Recommend the Good Stuff</div>
      </div>
    </a>
    <div class="list" #siderContainer>
      <ng-container *ngFor="let item of menuItems">
        <ng-container *ngIf="!item.externalLink && !item.subLinks">
          <a
            [routerLink]="item.routerLink"
            class="list__item"
            routerLinkActive="active"
            [attr.id]="item.id ? item.id : null"
            *ngIf="item?.condition?.expression"
          >
            <i class="icon" [class]="item.iconClass"></i>
            <div class="text">{{ item.label }}</div>
            <ng-container *ngFor="let sub of item.subText">
              <span class="sub-text" *ngIf="sub.condition">
                {{ sub.text }}
              </span>
            </ng-container>
          </a>
        </ng-container>
        <ng-container *ngIf="item.subLinks">
          <a
            class="list__item"
            href="#{{ item.collapseId }}"
            data-toggle="collapse"
            aria-expanded="false"
            (click)="$event.preventDefault()"
            *ngIf="item?.condition?.expression"
          >
            <i class="icon" [class]="item.iconClass"></i>
            <div class="text">
              {{ item.label }} <i class="fa-solid fa-angle-down"></i>
            </div>
          </a>
          <div [id]="item.collapseId" class="collapse" routerLinkActive="show">
            <ng-container *ngFor="let subItem of item.subLinks">
              <a
                [routerLink]="subItem.routerLink"
                class="list__item"
                routerLinkActive="active"
                *ngIf="!subItem.externalLink && subItem.condition?.expression"
              >
                <i class="icon" [class]="subItem.iconClass"></i>
                <div class="text">{{ subItem.label }}</div>
                <ng-container *ngFor="let sub of subItem.subText">
                  <span class="sub-text" *ngIf="sub.condition">
                    {{ sub.text }}
                  </span>
                </ng-container>
              </a>
              <a
                *ngIf="subItem.externalLink"
                [href]="subItem.externalLink"
                target="_blank"
                class="list__item"
              >
                <i class="icon" [class]="subItem.iconClass"></i>
                <div class="text">{{ subItem.label }}</div>
              </a>
            </ng-container>
          </div>
        </ng-container>
        <a
          *ngIf="item.externalLink && item?.condition?.expression"
          [href]="item.externalLink"
          target="_blank"
          class="list__item"
        >
          <i class="icon" [class]="item.iconClass"></i>
          <div class="text">{{ item.label }}</div>
        </a>
      </ng-container>
    </div>
  </div>

  <div class="main-content">
    <nav>
      <span class="hamburger-icon {{ slider }}" (click)="sideFun()">
        <span></span>
        <span></span>
        <span></span>
      </span>
      <div class="options">
        <div class="options__my-drop">
          <button (click)="message = !message">
            <i class="fa-solid fa-message"></i>
          </button>
          <div class="options__box" [ngClass]="{ active: message }">
            <div class="options__box--header">
              <div class="name">ANNOUNCEMENTS</div>
              <div class="number">{{ announcements?.length }} items</div>
            </div>
            <div class="options__box--body">
              <div
                class="options__box--body__item"
                *ngFor="let announcement of announcements"
                (click)="openAnnModal(announcement.id)"
              >
                <img loading="lazy"
                  src="{{ imgUrl }}{{ announcement.image }}"
                  *ngIf="announcement.image != ''"
                />
                <img loading="lazy"
                  src="../../../../assets/images/new/megaphone.png"
                  *ngIf="announcement.image == ''"
                />
                <div>
                  <div class="options__box--body__item--name">
                    {{ announcement.title.substr(0, 70)
                    }}<i *ngIf="announcement.titleLength > 70">...</i>
                  </div>
                  <div class="options__box--body__item--date">
                    {{ announcement.created * 1000 | date : "medium" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="options__my-drop">
          <button (click)="notificate = !notificate">
            <i class="fa-solid fa-bell"></i>
          </button>
          <div class="options__box" [ngClass]="{ active: notificate }">
            <div class="options__box--header">
              <div class="name">NOTIFICATIONS</div>
              <div class="number">{{ notifications?.length }} items</div>
            </div>
            <div class="options__box--body">
              <div
                class="options__box--body__item"
                *ngFor="let notification of notifications"
              >
                <img loading="lazy"
                  src="../../../../assets/images/new/coin$s.svg"
                  class="rounded"
                  *ngIf="notification.viptoken_deduct_id == 0"
                />
                <img loading="lazy"
                  src="../../../../assets/images/new/google_iocn.png"
                  class="rounded"
                  *ngIf="
                    notification.viptoken_txn_id == 0 &&
                    notification.viptoken_deduct.type == 1
                  "
                />
                <img loading="lazy"
                  src="../../../../assets/images/gbb.png"
                  class="rounded"
                  *ngIf="
                    notification.viptoken_txn_id == 0 &&
                    notification.viptoken_deduct.type == 6
                  "
                />
                <img loading="lazy"
                  src="../../../../assets/images/gg.png"
                  class="rounded"
                  *ngIf="
                    notification.viptoken_txn_id == 0 &&
                    notification.viptoken_deduct.type == 4
                  "
                />
                <img loading="lazy"
                  src="../../../../assets/images/st.png"
                  class="rounded"
                  *ngIf="
                    notification.viptoken_txn_id == 0 &&
                    notification.viptoken_deduct.type == 5
                  "
                />
                <img loading="lazy"
                  src="../../../../assets/images/tp_stand.jpg"
                  class="rounded"
                  *ngIf="
                    notification.viptoken_txn_id == 0 &&
                    notification.viptoken_deduct.type == 7
                  "
                />
                <div>
                  <div class="options__box--body__item--name">
                    {{ notification.text }}
                  </div>
                  <div class="options__box--body__item--details">
                    <div class="options__box--body__item--date">
                      {{ notification.created * 1000 | date : "medium" }}
                    </div>
                    <i
                      class="fas fa-download"
                      *ngIf="notification.viptoken_deduct_id == 0"
                      title="Download receipt"
                      (click)="
                        downloadReceipt(
                          notification.viptoken_txn.stripe_invoice_id
                        )
                      "
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="options__profile">
          <div class="user" (click)="profile = !profile">
            <img loading="lazy" src="../../../../assets/images/1.jpg" alt="" />
            <div>
              <div class="name">Welcome {{ adminName }}</div>
              <div class="mail">{{ adminEmail }}</div>
            </div>
          </div>
          <div class="options__box" [ngClass]="{ active: profile }">
            <a routerLink="/admin/edit-profile"> Edit profile </a>
            <a (click)="logout()">Log out</a>
          </div>
        </div>
      </div>
    </nav>
    <div
      class="overlay"
      *ngIf="slider == 'open'"
      (click)="slider = 'close-side'"
    ></div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
